var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser24 = function SvgUser24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM9 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM10.143 14A6.143 6.143 0 0 0 4 20.143C4 21.169 4.831 22 5.857 22h12.286A1.857 1.857 0 0 0 20 20.143 6.143 6.143 0 0 0 13.857 14h-3.714Zm3.714 2a4.143 4.143 0 0 1 4.14 4H6.003c.076-2.222 1.9-4 4.14-4h3.715Z",
    fill: "currentColor"
  })));
};
export default SvgUser24;